module.exports = __webpack_public_path__ + "img/header_bg.5cd7acb4.png";